<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="assetName"
              label="Asset Name"
              type="text"
              class="mr-1"
              v-model="queryParams.assetName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="assetType"
              label="Asset Type"
              type="text"
              class="mr-1"
              v-model="queryParams.assetType"
            ></v-text-field>
          </v-flex>
          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-data-table
            v-model="selectedAssetList"
            :headers="headers"
            :items="assetList"
            select-all
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    primary
                    hide-details
                    @click.native="toggleAllAssets()"
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                </th>
                <th v-for="header in props.headers" :key="header.text">
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  primary
                  hide-details
                  :input-value="props.selected"
                  :value="props.item"
                  :indeterminate="props.indeterminate"
                  v-model="selectedAssetList"
                  multiple
                ></v-checkbox>
              </td>
              <td>{{ props.item.assetName }}</td>
              <td>{{ props.item.assetType }}</td>
              <td>{{ props.item.cost }}</td>
              <td>{{ props.item.description }}</td>
            </template>
          </v-data-table>
          <div class="text-xs-right">
            <v-btn color="primary" @click="dialogClose">Ok</v-btn>
          </div>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
    
    
  <script>
import { assetService } from "../../services/asset-service";

export default {
  name: "MultiSelectAssetDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },

  data: () => ({
    showListLoading: false,
    queryParams: {
      assetName: "",
      assetType: "",
      statusList: [],
    },
    headers: [
      { text: "Asset Name", align: "left", value: "assetName" },
      { text: "Asset Type", value: "assetType" },
      { text: "Cost", value: "cost" },
      { text: "Description", value: "description" }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "assetName",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    assetList: [],
    selectedAssetList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getAssetList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {

          this.queryParams = {
            ...this.params
          };
          this.selectedAssetList = [];
          this.assetList = [];
          this.getAssetList();
        }
      },
    },
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getAssetList();
    },
    getAssetList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      assetService
        .getAssetList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.assetList = res.data.assetList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose() {
      this.$emit("close", this.selectedAssetList);
    },
    toggleAllAssets() {
      if (this.selectedAssetList.length) {
        this.selectedAssetList = [];
      } else {
        this.selectedAssetList = this.assetList.slice();
      }
    },
  },
};
</script>
  